export class Constants {
  // OIDC constants
  public static clientRoot = `${ location.origin }/`;
  public static apiRoot = `${ location.origin }/api/`;

  // Miscellaneous constants
  public static kiloByteSize = 1024;
  public static mobileDeviceThreshold = 768;
  public static maxPageSize = 50;
  public static maskedWageValue = '****.**';

  // Configuration url
  public static configurationUri = 'api/configuration-properties';

  // API endpoints
  public static apiUrl = 'api/';
  public static readonly attachmentsServiceUrl = `${ Constants.apiUrl }incidents/{incidentId}/attachments`;
  public static readonly authServiceUrl = `${ Constants.apiUrl }auth`;
  public static readonly clientsServiceUrl = `${ Constants.apiUrl }clients`;
  public static readonly configurationServiceUrl = `${ Constants.apiUrl }configuration-properties`;
  public static readonly enumerationsServiceUrl = `${ Constants.apiUrl }enums`;
  public static readonly healthServiceUrl = `${ Constants.apiUrl }health`;
  public static readonly incidentsServiceUrl = `${ Constants.apiUrl }incidents`;
  public static readonly incidentsMetadataUrl = `${ Constants.incidentsServiceUrl }/metadata`;
  public static readonly jurisdictionsServiceUrl = `${ Constants.apiUrl }jurisdictions`;
  public static readonly questionnairesServiceUrl = `${ Constants.apiUrl }questionnaires`;
  public static readonly usersServiceUrl = `${ Constants.apiUrl }users`;
  public static readonly businessUnitsUrl = `${ Constants.clientsServiceUrl }/{clientNumber}/business-units/{businessUnitId}`;
  public static readonly startingLocationsUrl = `${ Constants.clientsServiceUrl }/{clientNumber}/user-starting-locations`;
  public static readonly businessUnitAncestorsUrl = `/api/business-units/{businessUnitId}/tree-view`;
  public static readonly policyServiceUrl = `${ Constants.apiUrl }policies`;
  public static readonly preQuestionDataUrl = `${ Constants.apiUrl }pre-question-data`;
  public static readonly employeesUrl = `${ Constants.apiUrl }employees`;
  public static readonly branchesUrl = `${ Constants.apiUrl }branches`;
  public static readonly contactsUrl = `${ Constants.apiUrl }contacts`;
  public static readonly branchRuleExecuteUrl = `${ Constants.apiUrl }rules/UI_BRANCH_LOOKUP_SELECTED/run`;
  public static readonly contactRuleExecuteUrl = `${ Constants.apiUrl }rules/UI_CONTACT_LOOKUP_SELECTED/run`;
  public static readonly vehicleRuleExecuteUrl = `${ Constants.apiUrl }rules/UI_VEHICLE_LOOKUP_SELECTED/run`;
  public static readonly productRuleExecuteUrl = `${ Constants.apiUrl }rules/UI_PRODUCT_LOOKUP_SELECTED/run`;
  public static readonly incidentsDuplicateCheckUrl = `${ Constants.apiUrl }duplicate-check`;
  public static readonly vehiclesUrl = `${ Constants.apiUrl }vehicles`;
  public static readonly vehicleHistoricalLocationsUrl = `${ Constants.vehiclesUrl }/{vehicleId}/historical-locations`;
  public static readonly verificationCodeSendUrl = `${ Constants.apiUrl }auth/verification-code/send`;
  public static readonly verificationCodeCheckUrl = `${ Constants.apiUrl }auth/verification-code/validate`;
  public static readonly productsServiceUrl = `${ Constants.apiUrl }products`;
  public static readonly vendorConfirmationUrl = `${ Constants.apiUrl }vendor/confirmation`;
  public static readonly vehicleValidationUrl = `${ Constants.vehiclesUrl }/validation`;

  // Reporter Admin auth endpoint
  public static readonly handOffCookiePath = '/';

  // Login hand-off to another application
  public static readonly authRedirectAppParam = 'authRedirectApp';
  public static readonly authRedirectAppStorageKey = 'reporterAuthRedirectApp';
  public static readonly authRedirectAppLandingUrlKeys = new Map<string, string> ( [
    [ 'REPORTER', 'admin.redirect-auth-url' ],
    [ 'FEEDS_MANAGER', 'feeds-manager.redirect-auth-url' ],
    [ 'FED', 'fed.redirect-auth-url' ],
  ] );
  // Apps that get their own token and must not turn it into a Reporter session
  public static readonly authRedirectHandOffApps: string[] = [ 'FEEDS_MANAGER', 'FED' ];

  // MFA
  public static readonly mfaTokenExchangeUrl = `${ Constants.authServiceUrl }/mfa/exchange`;
  public static readonly mfaCallbackTokenParam = 'T';

  // Conversational AI
  public static readonly aiTokenUrl = `${ Constants.authServiceUrl }/conversational-ai`;
  public static readonly aiTokenCookieName = 'conv-ai-token';
  public static readonly aiTokenCookiePath = '/';
  public static readonly mfaNoticeEnabledConfigKey = 'com.mvsc.reporter.mfa-notice.enabled';

  // Routes where JwtInterceptor must not replace the Authorization header with the stored access token
  public static readonly jwtDisallowedRoutes = [
    /(api\/auth\/login)/,
    /(api\/auth\/mfa\/exchange)/,
    /(api\/custom-ui-configs\/*)/,
    /(api\/vendor\/confirmation\/*)/,
    /(api\/auth\/app-token\/*)/,
  ];

  // Prompts
  public static readonly reportingLocationPrompt = 'Reporting Location';
  public static readonly dateOfLossPrompt = 'Date of Loss';
  public static readonly nonWcBenefitStatePrompt = 'Benefit State';
  public static readonly wcBenefitStatePrompt = 'Benefit State';
  public static readonly buReferenceNumberPrompt = 'Location Code';

  // LocalStorage Keys
  public static readonly localStorageKeys = {
    reporterUser: 'reporterUser',
    reporterCurrentClient: 'reporterCurrentClient',
    reporterBusinessUnitsSettings: 'reporterBusinessUnitsSettings',
    reporterAccessToken: 'reporterAccessToken',
    reporterAuthUiConfigUrlSegmentKey: 'reporterAuthUiConfigUrlSegmentKey',
    reporterConfig: 'reporterConfig',
    ___gbru: '___gbru',
    reporterClientSelected: btoa ( 'reporterClientSelected' ),
    uiConfig: 'uiConfig',
    fedEmailDirectMessageId: 'fedEmailDirectMessageId',
    reporterPendingMfa: 'reporterPendingMfa',
    reporterContactEmailUpdateRequired: 'reporterContactEmailUpdateRequired',
  };

  // SessionStorage Keys
  public static readonly contactEmailPendingRedirectStorageKey = 'reporterContactEmailPendingRedirect';

  // Contact email that marks a user profile as having no valid contact email
  public static readonly invalidContactEmail = 'devnull@mvsc.com';

  // UI Config
  public static readonly uiConfigServiceUrl = '/api/custom-ui-configs';
  public static readonly uiConfigDefault = {
    landingPageFooterHtmlSnippet: '',
    landingPageHeaderHtmlSnippet: '<h3>Welcome to GBGO® firstconnect</h3>' +
      'For your convenience, please bookmark this page.',
    ssoButtonText: 'LOGIN USING SINGLE SIGN ON',
    whiteLabelLogoUri: 'assets/images/GB_logo.png',
  };
}
